export default __webpack_public_path__ + "static/media/happy-birthday.7b64b166.webp";